<div class="h-screen flex flex-col">
  <header>
    <app-navbar></app-navbar>
  </header>

  <main class="grow p-3">

    @if (invite.isLoading() || acceptance.isLoading() || user.isLoading()) {
      <div class="flex flex-col items-center justify-center h-full">
        <fa-icon icon="circle-notch" animation='spin' size="3x"></fa-icon>
      </div>
    } @else if (!acceptance.value()) {

      @let i = invite.value()!;

      <p class="text-xl mt-6">
        You are invited to join
        <strong class="text-lg">{{i.course.name}}</strong>
      </p>

      <div class="my-6 surface-container p-3 rounded">

        <div class="flex flex-row gap-3">
          @if (i.createdBy) {
            <div class="flex-shrink-0 ">
              <app-avatar [user]="i.createdBy" size="sm"></app-avatar>
            </div>
          }

          <div>
            <div [innerHtml]="i.message">
            </div>
            @if (selfieRequired()) {
              <p>
                It is best to accept this invite on a phone or some device with a camera, because you will be asked to take a selfie during the registration process. This is to help build a sense of community by helping everyone in class put names to faces easily.
              </p>
            }
            @if (i.createdBy) {
              <p class="text-muted">
                {{i.createdBy.givenName}} {{i.createdBy.familyName}}
              </p>
            }
          </div>

        </div>
      </div>

      @if (!user.value()) {
        <p>
          Please <a (click)="signIn()">sign in</a> to accept this invite.
        </p>
      } @else if (hasInvalidEmail()) {
        <p>
          This invite requires that you sign in with an email address that ends with
          @for (suffix of i.requirements.emailSuffixes ; track suffix ; let first = $first ; let last = $last) {
            @if(!first && !last) {, }
              @if (!first && last) { or }
                <strong>...{{suffix}}</strong>
              }
            </p>
            <p>
              Please <a (click)="signIn()">sign in</a> with a different account to accept this invite.
            </p>
          } @else if (missingProfileFields().length) {
            <p>
              To accept this invite, please <a (click)="editProfile()">edit your profile</a> to include
              @for (field of i.requirements.fields ; track field ; let first = $first ; let last = $last) {
                @if(!first && !last) {, }
                  @if (!first && last) { or }
                    <strong [matTooltip]="$requirements.getFieldDescription(field)">{{$requirements.getFieldName(field)}}</strong>
                  }
                </p>
              } @else {
                <button (click)="accept()" mat-flat-button color="primary" class="w-full">Accept Invite</button>
              }
            } @else {

              @let i = invite.value()!;

              <p class="text-xl mt-6">
                You have joined
                <strong class="text-lg">{{i.course.name}}</strong>
              </p>

              @if (!acceptees.isLoading()) {
                <p class="my-6">
                  We'll see you soon!
                </p>
              }

              @if (acceptees.isLoading()) {
                <div class="bg-slate-800 rounded-lg text-center p-6">
                  <fa-icon icon="circle-notch" animation='spin' size="3x"></fa-icon>
                </div>
              }

              @if (acceptees.value()) {
                <div>
                  <div class="surface-container rounded-t-lg flex flex-row justify-between items-center">
                    <span class="text-sm px-3">Your classmates</span>
                    <mat-paginator
                      (page)="setPage($event.pageIndex)"
                      [length]="acceptees.value()!.totalElements"
                      [pageSize]="acceptees.value()!.pageable.pageSize"
                      [showFirstLastButtons]="true"
                      [hidePageSize]="true"
                      [pageIndex]="acceptees.value()!.pageable.pageNumber"
                      aria-label="Select page">
                    </mat-paginator>
                  </div>
                  @for (acceptee of acceptees.value()!.content; track acceptee) {
                    <div class="surface-container mt-1 last:rounded-b-lg">
                      <div class="flex flex-row justify-between items-center p-3">
                        <div class="flex flex-row items-center gap-3">
                          <app-avatar [user]="acceptee" size="sm"></app-avatar>
                          <div>
                            <p class="text-lg">
                              {{acceptee.givenName}} {{acceptee.familyName}}
                            </p>
                            <p class="mt-1 text-sm">
                              @if(acceptee.bio) {
                                {{acceptee.bio}}
                              } @else {
                                <span class="text-muted">No bio provided</span>
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            }

          </main>

          <footer>
            <app-footer></app-footer>
          </footer>
        </div>
